import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

const headerHeight = 76;

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    paper: {
      width: '100%',
      maxWidth: 880,
    },
    header: {
      height: headerHeight,
      maxWidth: 880,
      zIndex: 1,
      padding: spacing(5),
    },
    content: {
      padding: spacing(5),
      flex: 1,
      overflow: 'auto',
    },
    cardsWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(6),
      overflow: 'visible',
    },
    cardsWrapFullWidth: {},
    headerTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
      marginTop: 9,
    },
    thirdStepHeader: {
      fontSize: 18,
      marginBottom: 22,
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      padding: spacing(5),
      paddingBottom: 19,
      backgroundColor: colors.grey.body,
      marginTop: 0,
      overflow: 'visible',
    },
    cardHeader: {
      marginBottom: spacing(4),
    },
    cardTitle: {
      fontSize: 18,
      color: colors.black.darker,
      fontWeight: 500,
    },
    radioRoot: {
      marginBottom: spacing(3),
    },
    radioWrapper: {
      marginRight: spacing(3),
    },
    divider: {
      height: 1,
      width: '100%',
      backgroundColor: colors.grey.light,
      margin: spacing(4, 0),
    },
    subHeaderLabel: {
      fontSize: 16,
      fontWeight: 500,
      color: colors.kato.neutral[900],
      display: 'block',
      marginBottom: spacing(3),
    },
    inputField: {
      marginBottom: spacing(6),
      '&:first-child': {
        backgroundColor: colors.white.lightest,
      },
    },
    label: {
      fontSize: 14,
      color: colors.grey.darker,
    },
    inputsGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: spacing(6),
    },
    filter: {
      width: '48%',
    },
    groupedInput: {
      width: '48%',
    },
    groupedInputLabel: {
      color: colours.neutral[900],
      marginBottom: spacing(2),
      lineHeight: 1,
    },
    groupedSelect: {
      width: '100%',
    },
    bottomButtonWrap: {
      width: '100%',
      marginTop: spacing(6),
      marginBottom: spacing(6),
      display: 'flex',
      justifyContent: 'end',
    },
    mapLocateError: {
      color: colors.red.darkish,
      marginBottom: spacing(5),
    },
    markerIconButton: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    markerIcon: {
      fontSize: 30,
    },
    bottomSubmitBtn: {},
    stepHelpText: {
      display: 'flex',
      width: '100%',
      marginTop: spacing(6),
      marginBottom: spacing(6),
      color: colors.grey.main,
      cursor: 'pointer',
      '&:hover': {
        color: colors.black.darkest,
      },
    },
    paperFooter: {
      paddingTop: spacing(5),
      marginTop: spacing(5),
      borderTop: `1px solid ${colors.grey.lightest}`,
      width: '100%',
    },
    defaultText: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 500,
      color: colors.grey.darker,
    },
    changeAssigneeBtn: {
      color: colors.blue.dark,
      fontSize: 14,
      marginLeft: spacing(1),
      cursor: 'pointer',
      '&:hover': {
        color: colors.blue.main,
      },
    },
    assigneeValidation: {
      color: colors.red.darkish,
      marginTop: '10px 0',
    },
    userAutocomplete: {
      marginBottom: spacing(5),
    },
    eventsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      marginTop: spacing(3),
    },
    addEventButton: {
      alignSelf: 'flex-start',
      marginTop: spacing(4),
    },
    sectionDivider: {
      borderTop: `1px solid ${colors.grey.light}`,
      marginBottom: spacing(4),
      marginTop: spacing(4),
      width: '100%',
    },
    manageSection: {
      border: 'none',
      '& > div:first-child': {
        backgroundColor: colors.grey.body,
      },
      '& > div:last-child': {
        backgroundColor: colors.grey.body,
      },
    },
    footerButtons: {
      display: 'flex',
      gap: spacing(3),
      width: '100%',
    },
    supportLink: {
      color: colors.blue.dark,
      textDecoration: 'underline',
      '&:hover': {
        color: colors.blue.main,
      },
    },
    transactionNotesField: {
      marginTop: spacing(3),
    },
  });
